import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import LabeledReadOnly from "../../components/LabeledReadOnly";
import ReadOnlyField from "../../components/ReadOnlyField";
import { DateTime } from "luxon";

const MetadataFileDiscoveryErrorDialog = ({
  metadataFileDiscoveryError,
  open,
  onCancel,
}) => {
  return (
    <Dialog fullWidth maxWidth="md" open={open}>
      <DialogTitle id="form-dialog-title">
        Metadata File Discovery Error
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <LabeledReadOnly label="Event Timestamp">
              <ReadOnlyField>
                {DateTime.fromISO(metadataFileDiscoveryError.eventTimestamp)
                  .toUTC()
                  .toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={6}>
            <LabeledReadOnly label="Event Type">
              <ReadOnlyField>
                {metadataFileDiscoveryError.eventType}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="Job Id">
              <ReadOnlyField>{metadataFileDiscoveryError.jobId}</ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="Execution Id">
              <ReadOnlyField>
                {metadataFileDiscoveryError.executionId}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="Media Id">
              <ReadOnlyField>
                {metadataFileDiscoveryError.mediaId}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="State Machine">
              <ReadOnlyField>
                {metadataFileDiscoveryError.stateMachine}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={6}>
            <LabeledReadOnly label="Task Name">
              <ReadOnlyField>
                {metadataFileDiscoveryError.taskName}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={6}>
            <LabeledReadOnly label="Number of Retries">
              <ReadOnlyField>
                {metadataFileDiscoveryError.taskRetry}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={6}>
            <LabeledReadOnly label="Message">
              <ReadOnlyField>
                {metadataFileDiscoveryError.message}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MetadataFileDiscoveryErrorDialog;
